// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"SuccessPopup__Wrapper_25C4D","Title":"SuccessPopup__Title_2kMSZ"};